import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

declare type ButtonType = 'flat' | 'raised';

@Component({
  standalone: true,
  imports: [NgSwitchCase, NgSwitch, MatButtonModule, MatProgressSpinnerModule, NgIf, TranslateModule],
  selector: 'app-va-common-button',
  styleUrls: ['va-button.component.scss'],
  template: `
    <ng-container [ngSwitch]="buttonType">
      <button
        *ngSwitchCase="'flat'"
        mat-flat-button
        [color]="warn ? 'warn' : 'primary'"
        [disabled]="isDisabled"
        (click)="click()"
      >
        <span class="loading-container">
          <mat-progress-spinner
            *ngIf="loading"
            class="loader"
            [strokeWidth]="4"
            [diameter]="24"
            mode="indeterminate"
          ></mat-progress-spinner>
        </span>
        <span [style.visibility]="loading ? 'hidden' : 'visible'">{{ buttonText }}</span>
      </button>

      <button
        *ngSwitchCase="'raised'"
        mat-raised-button
        [color]="warn ? 'warn' : 'primary'"
        [disabled]="isDisabled"
        (click)="click()"
      >
        <span class="loading-container">
          <mat-progress-spinner
            *ngIf="loading"
            class="loader"
            [strokeWidth]="4"
            [diameter]="24"
            mode="indeterminate"
          ></mat-progress-spinner>
        </span>
        <span [style.visibility]="loading ? 'hidden' : 'visible'">{{ buttonText | translate }}</span>
      </button>
    </ng-container>
  `,
})
export class VaButtonComponent {
  @Input() buttonText: string;
  @Input() buttonType: ButtonType = 'flat';
  @Input() warn = false;
  @Input() loading = false;
  @Input() disabled = false;
  @Output() clicked: EventEmitter<boolean> = new EventEmitter();

  get isDisabled(): boolean {
    return this.disabled || this.loading;
  }

  click(): void {
    if (!this.isDisabled) {
      this.clicked.emit();
    }
  }
}
